var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113.35 122.88",
    style: {
      enableBackground: "new 0 0 113.35 122.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.65,57.74c11.66,2.69,19.86,6,24.56,9.87c6.77,5.51,10.14,12.62,10.14,21.37c0,9.25-3.71,16.89-11.13,22.92 c-9.12,7.33-22.39,10.98-39.77,10.98H0v-3.34c5.69,0,9.52-0.53,11.57-1.61c2.01-1.05,3.43-2.41,4.24-4.11 c0.83-1.7,1.24-5.85,1.24-12.49V21.59c0-6.65-0.4-10.83-1.24-12.56C15,7.3,13.55,5.94,11.5,4.92C9.46,3.87,5.63,3.37,0,3.37L0,0 h58.89c14.07,0,24.06,1.27,29.91,3.78c5.88,2.51,10.49,6.25,13.86,11.23c3.4,4.98,5.07,10.3,5.07,15.9c0,5.94-2.13,11.2-6.43,15.84 C97.02,51.34,89.47,55.02,78.65,57.74L78.65,57.74z M45.68,55.27c8.57,0,14.88-0.96,18.96-2.88c4.08-1.95,7.21-4.67,9.4-8.17 c2.17-3.49,3.25-7.98,3.25-13.42c0-5.41-1.08-9.86-3.22-13.36c-2.13-3.46-5.19-6.09-9.18-7.92C60.9,7.7,54.5,6.84,45.68,6.9V55.27 L45.68,55.27L45.68,55.27z M45.68,62.35v39.4l-0.09,4.55c0,3.25,0.8,5.72,2.48,7.39c1.67,1.64,4.11,2.47,7.39,2.47 c4.82,0,9.28-1.05,13.36-3.22c4.08-2.13,7.2-5.26,9.37-9.34c2.2-4.05,3.28-8.6,3.28-13.61c0-5.75-1.33-10.92-3.99-15.46 c-2.66-4.55-6.31-7.73-10.98-9.56C61.86,63.16,54.9,62.29,45.68,62.35L45.68,62.35L45.68,62.35z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.5d56d9251e6cdb6a267eee655ff60f96.svg";
export { ForwardRef as ReactComponent };